import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function HeaderLogo({ height, variant, blur, sx }) {
  const theme = useTheme();
  const useWhite = variant === 'white' || (variant === 'auto' && theme.palette.mode === 'dark');
  const src = useWhite ? '/static/header_logo_white.svg' : '/static/header_logo_color.svg';

  return (
    <Box
      component="img"
      alt="Logo"
      src={src}
      sx={{
        height,
        width: 'auto',
        display: 'block',
        filter: `blur(${blur}px)`,
        ...sx,
      }}
    />
  );
}

HeaderLogo.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  variant: PropTypes.oneOf(['auto', 'white']),
  blur: PropTypes.number,
  sx: PropTypes.object,
};

HeaderLogo.defaultProps = {
  height: 36,
  variant: 'auto',
  blur: 0.4,
  sx: undefined,
};

export default HeaderLogo;
